<template>
  <block-item-card
    :min-height="minBlockHeight"
    :title="$t('ALM.Section.InvestmentsPortfolio.CreditQuality.Title')"
  >
    <v-row class="ma-0">
      <!-- Left Section - Donut Chart -->
      <v-col
        class="ma-0 pa-2"
        cols="12"
        md="3"
      >
        <div class="text-center">
          <!-- Donut Chart -->
          <v-lazy
            :options="{threshold: .5}"
            transition="fade-transition"
          >
            <base-e-chart-pie
              :chart-data-options="creditQualityData"
              :chart-height="200"
              :tooltip-show="true"
              chart-animation-easing="elasticOut"
              tooltip-confine
              :label-line-show="false"
              :label-show="false"
              :legend-show="false"
              :default-colors="pieColors"
              :tooltip-suffix="'%'"
            />
          </v-lazy>
        </div>
      </v-col>

      <!-- Right Section - Data Table -->
      <v-col
        class="ma-0 pa-2"
        cols="12"
        md="9"
      >
        <div>
          <v-row no-gutters>
            <v-col
              cols="12"
              class="d-flex justify-space-between"
              style="width: 100%;"
            >
              <div class="table-header synthesis-brand-dark-blue--text pa-1 pl-4">
                {{ $t('ALM.Section.InvestmentsPortfolio.CreditQuality.TableHeaders.Rating') }}
              </div>
              <div class="table-header synthesis-brand-dark-blue--text pa-1 pr-4">
                {{ $t('ALM.Section.InvestmentsPortfolio.CreditQuality.TableHeaders.Contribution') }}
              </div>
            </v-col>
          </v-row>

          <v-row
            v-for="(rating, index) in perRatingContribution"

            :key="`alm-investments-portfolio-investments-allocation-legend-${index}`"
            no-gutters
          >
            <v-col
              cols="12"
            >
              <item-chart-legend
                :key="`alm-investments-portfolio-investments-allocation-legend-size-${index}`"
                :background-color="themeColorRGBA(getColorByIndex(index), 1)"
                :title="`${rating.rating.toString()}`"
                :title-value="`${rating.contribution ? formatNumberShort(rating.contribution) : ''}`"
                :title-size="14"
                :title-value-size="14"
                :title-value-class="'font-weight-medium d-flex align-center'"
                icon="mdi-circle"
                :icon-color="themeColorRGBA(getIconColorByIndex(index), 1)"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              cols="12"
            >
              <item-chart-legend
                :key="`alm-investments-portfolio-investments-allocation-legend-size`"
                :title="`${$t('ALM.Section.InvestmentsPortfolio.CreditQuality.TableHeaders.Total')}`"
                :title-size="14"
                :title-class="'font-weight-bold d-flex align-center'"
                :title-value="totalContribution ? formatNumberShort(totalContribution) : ''"
                :title-value-size="14"
                :title-value-class="'font-weight-bold d-flex align-center'"
                :border="`1px solid ${themeColorRGBA('synthesis-ui-grey-02', 1)}`"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </block-item-card>
</template>

  <script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'
import { toNumberFormatNotationShort } from '@/lib/utils/helper'
import ItemChartLegend from '@/theme/default/components/common/ItemChartLegend'
import BaseEChartPie from '@/theme/default/components/charts/echarts/BaseEChartPie'

export default {
  name      : 'CreditQuality',
  components: {
    BlockItemCard,
    ItemChartLegend,
    BaseEChartPie
  },
  mixins   : [chartsColorMixin],
  props    : {},
  dataStore: {
    Investments: 'ALM.Investments.Data'
  },
  data () {
    return {
      minBlockHeight: 350,
      switchValue   : true

    }
  },
  computed: {
    creditQuality () {
      return this.Investments?.CreditQuality || {}
    },

    creditQualityRatings () {
      return this.creditQuality?.ratings || []
    },

    perRatingContribution () {
      return this.creditQuality?.perRatingContribution || []
    },

    totalContribution () {
      return 100
    },

    creditQualityData () {
      if (!this.perRatingContribution) return null

      const sortedData = [...this.perRatingContribution]

      return sortedData.map((item, index) => ({
        name     : item.rating,
        value    : item.contribution,
        type     : 'number',
        itemStyle: {
          color: this.themeColorRGBA(this.getIconColorByIndex(index), 1)
        }
      }))
    },

    pieColors () {
      return ['#EA804B', '#57C05B', '#C264DE', '#FFB21E']
    }
  },

  watch: {
    selectedPeriod () {
      this.updateResourcePeriod()
    }
  },
  mounted () {},
  methods: {
    formatNumberShort (value) {
      return toNumberFormatNotationShort(value) + '%'
    },
    getInvestmentTypeIconColor (index) {
      return ['#EA804B', '#57C05B', '#C264DE', '#FFB21E'][index % 4]
    },
    getColorByIndex (index) {
      switch (index) {
        case 0:
          return 'synthesis-ui-orange-08'
        case 1:
          return 'synthesis-ui-green-08'
        case 2:
          return 'synthesis-ui-purple-08'
        case 3:
          return 'synthesis-ui-yellow-08'
        default:
          return 'synthesis-ui-grey-08'
      }
    },
    getIconColorByIndex (index) {
      switch (index) {
        case 0:
          return 'synthesis-ui-orange-01'
        case 1:
          return 'synthesis-ui-green-01'
        case 2:
          return 'synthesis-ui-purple-01'
        case 3:
          return 'synthesis-ui-yellow-01'
        default:
          return 'synthesis-ui-grey-01'
      }
    }

  }
}
  </script>

  <style scoped>

  .table-header {
  font-size: 12px;
  font-weight: 400;

}
  </style>
